import { reactive, computed, onMounted, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router'
import Tab from '../../../components/ui/tab/index.vue';
import Select from '../../../components/ui/select/index.vue';
import Button from '../../../components/ui/button/index.vue';
import Table from '../../../components/ui/tablebox/index.vue';
import CTmenu from '../../../components/ui/ctmenu/index.vue';
import Pagination from '../../../components/ui/pagination/index.vue';
import { ACTIONBAR, FEATURENAME } from '@//enum/enum';
import { apiGetNotifications, apiGetGroupModel, apiSetNotification_delete, apiSetNotification_approve, apiNotificationsCount } from '@/api/api';
import { dateTimeHandle } from '@/utils/time';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    Tab,
    Select,
    Button,
    Table,
    CTmenu,
    Pagination,
  },
  props: {
  },
  setup(props, { emit }) {//emit 傳到複層_emit('update:{function}', val)
    const { icon, isCheck } = props;
    const store = useStore();
    const storeState = store.state;
    const { t, locale } = useI18n();
    const multiLang = reactive({
      initRawData: {},
    })
    //data
    let state = reactive({
      tab_data: [
        {
          name: 'Ask for Binding',
          id: "join",
          val: '0',
          disabled: false,
          alertText: '',
          isI18n: '__d7d_n17r.__askForBinding',
        }, {
          name: 'Ask for unlock function',
          id: "unlock",
          val: '1',
          disabled: false,
          alertText: '',
          isI18n: '__d7d_n17r.__askForUnlockFunction',
        }, {
          name: 'Unbind notification',
          id: "unbind",
          val: '2',
          disabled: false,
          alertText: '',
          isI18n: '__d7d_n17r.__unbindNotification',
        }, {
          name: 'Others',
          id: "other",
          val: '3',
          disabled: false,
          alertText: '',
          isI18n: '__d7d_n17r.__others',
        }
      ],
      tab: "join",
      device:
      {
        text: t('__d7d_n17r.__allDevices'),
        val: 'All',
        isI18n: '__d7d_n17r.__allDevices',
      },
      function_name: {
        text: t('__d7d_n17r.__allFunctions'),
        val: 'All',
        isI18n: '__d7d_n17r.__allFunctions',
      },
      askOP: [],
      device_op: [
        {
          text: t('__d7d_n17r.__allFunctions'),
          val: 'All',
          id: "All",
          isI18n: '__d7d_n17r.__allFunctions',
        },
      ],
      function_op: [
        {
          text: t('__d7d_n17r.__allFunctions'),
          val: 'All',
          id: "All",
          isI18n: '__d7d_n17r.__allFunctions',
        },
        {
          text: t('__d7d_n17r.__calibrationAndAppointment'),
          val: 'unlock_task',
          id: "unlock_task",
          isI18n: '__d7d_n17r.__calibrationAndAppointment',
        },
        {
          text: t('__d7d_n17r.__osdProfileSettings'),
          val: 'unlock_osd',
          id: "unlock_osd",
          isI18n: '__d7d_n17r.__osdProfileSettings',
        }
      ],
      meta: {
        total_page: 1,
        current: 1,
      },

      deviceListData: [],

      send: [],
      button_bool: true,
      sort: {
        key: "All",
        val: "All",
        index: "0"
      },
      defaultCheckIndexList: [],
    })



    //$i18n
    watch(
      () => locale,
      () => {
        orgDBD();
      },
      { deep: true }
    )

    const orgDBD = () => {
      let data = multiLang.initRawData
      state.deviceListData = [];
        for (var a = 0; a < data['data'].length; a++) {
          var _data = {
            serialNumber: data['data'][a].ssn,
            model: data['data'][a].model,
            pcName: data['data'][a].host,
            ipAddress: data['data'][a].ip,
            date: dateTimeHandle(data['data'][a].created_at),
            id: data['data'][a].id,
            device_id: data['data'][a].device_id,
          }
          if (data['data'][a].group) {
            var _group = "";
            for (var _g = 0; _g < data['data'][a].group.length; _g++) {
              if (_g != 0) {
                _group += "; " + data['data'][a].group[_g];
              } else {
                _group += data['data'][a].group[_g];
              }
            }
            _data["group"] = _group;
          }
          if (data['data'][a].unlock_task || data['data'][a].unlock_osd) {
            var _task = data['data'][a].unlock_task;
            var _osd = data['data'][a].unlock_osd;
            var _requirement = t('__d7d_n17r.__unlock') + ' ' ;
            if (_task == 1) {
              _requirement += t('__d7d_n17r.__calibrationAndAppointment')
            }
            if (_osd == 1) {
              if (_requirement == t('__d7d_n17r.__unlock')) {
                _requirement += t('__d7d_n17r.__osdProfileSettings')
              } else {
                _requirement += ` ;  ${t('__d7d_n17r.__osdProfileSettings')}`
              }
            }
            _data["requirement"] = _requirement;
          }
          var _message = t('__d4e_m8t.__unbind');
          if (data['data'][a].message == 0) {
            _message = t('__d7d_n17r.__invitedRejected');
          } else if (data['data'][a].message == 1) {
            _message = t('__d7d_n17r.__taskLimited')
          } else if (data['data'][a].message == 10) {
            _message = t('__flash.__osdProfileApplySuccessfully')
          } else if (data['data'][a].message == 11) {
            _message = t('__flash.__osdProfileApplyFail')
          } else if (data['data'][a].message == 12) {
            _message = `${t('__flash.__osdProfileApplyFail')} failed (${t('__flash.__usbDisconnected')})`
          } else if (data['data'][a].message == 13) {
            _message = `${t('__flash.__osdProfileApplyFail')} failed (${t('__flash.__timeout')})`
          }
          _data["message"] = _message;
          state.deviceListData.push(_data);
      }
    }







    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })
    // methods
    const router = useRouter();
    const onClick = () => {
      router.push(`/${"main/dashboard/notification"}`);
    }
    const onClickTab = (v) => {
      state.device = {
        text: t('__d7d_n17r.__allDevices'),
        val: 'All',
        isI18n: '__d7d_n17r.__allDevices',
      };
      state.function_name = {
        text: t('__d7d_n17r.__allFunctions'),
        val: 'All',
        isI18n: '__d7d_n17r.__allFunctions',
      };

      state.tab = v.item.id;
      state.meta.current = 1;
      state.send = [];
      state.defaultCheckIndexList = [];
      state.sort = {
        key: "All",
        val: "All",
        index: "0"
      }
      getAPINotificationsData();

    }
    const tableSort = (v) => {
      // console.log(v,state.tab,'sort table')
      state.sort = v;
      getAPINotificationsData();
    }
    const onCheckAll = (v) => {
      console.log(v, 'table onCheck All')
      state.send = [];
      state.defaultCheckIndexList = [];
      v.forEach(element => {
        state.send.push(element)
        state.defaultCheckIndexList.push(element.tableId)
      });
    }

    const onCheckEach = (v) => {
      console.log(v, 'table onCheck Each')
      state.send = [];
      state.defaultCheckIndexList = [];
      v.forEach(element => {
        state.send.push(element)
        state.defaultCheckIndexList.push(element.tableId)
      });
    }



    const goTableLink = (v) => {
      console.log(v, 'table link')
      let ssn = v.val.serialNumber
      router.push({ name: FEATURENAME.DEVICEDETAIL, params: { name: ssn, tabId: ACTIONBAR.VIEWHIS } });
    }
    const approve_click = async (string) => {
      var _approve = true
      if (string == "reject") {
        _approve = false;
      }
      try {
        var _id = [];
        state.send.forEach(e => _id.push(e.device_id));
        var _data = {
          id: _id,
          approve: _approve,
          type: state.tab
        }
        // console.log('set approve', data);
        await apiSetNotification_approve(_data);
        state.meta.current = 1
        getAPINotificationsData();
        state.send = [];
      }
      catch (err) {
        console.log("apiSetNotification_approve", 'err')
      }
    }
    const delete_click = async () => {
      try {
        var _id = [];
        state.send.forEach(e => _id.push(e.id));
        var _data = {
          id: _id,
          type: state.tab
        }
        // const data = await apiSetNotification_delete(_data);
        // console.log('set delete', _data);
        await apiSetNotification_delete(_data);
        state.meta.current = 1
        getAPINotificationsData();
        state.send = [];
      }
      catch (err) {
        console.log("apiSetNotification_delete", 'err')
      }
    }
    const showCTAndRow = (v) => {
      console.log(v, 'show test  ContextMenu')
    }
    const changePage = (page) => {
      state.meta.current = page;
      state.defaultCheckIndexList = [];
      getAPINotificationsData();
    }


    const IsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })

    let interval = null;

    onMounted(() => {
      _init();
      interval = setInterval(() => {
        _init(false);
      }, storeState.updateTime);
    })

    onUnmounted(() => {
      clearInterval(interval);
    })


    const getAPINotificationsNew = async () => { //取得header的訊息總數
      try {
        const datas = await apiNotificationsCount();
        console.log('apiNotificationsCount', datas)
        let total = 0;
        if (!datas.status_code) {
          for (let key in datas) {
            if (key != "status_code" && key != "message") {
              total += datas[key]
            }
          }
          store.commit('setAlertNotification', total)
        }
      }
      catch (error) {
        return error;
      }
    }


    const colComputed = computed(() => {
      let col = []
      let join_col = [
        {
          title: t('__d7d_n17r.__serialNumber'),
          key: "serialNumber",
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "pcName",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__ipAddress'),
          key: "ipAddress",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__date'),
          key: "date",
          sort: true,
        },
      ]
      let unlook_col = [
        {
          title: t('__d7d_n17r.__serialNumber'),
          key: "serialNumber",
          isLink: true, //有連結
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "pcName",
          sort: true,
        },
        {
          title: t('__common.__group'),
          key: "group",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__requirement'),
          key: "requirement",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__date'),
          key: "date",
          sort: true,
        },
      ]
      let unbind_col = [
        {
          title: t('__d7d_n17r.__serialNumber'),
          key: "serialNumber",
          isLink: false, //沒有連結
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "pcName",
          sort: true,
        },
        {
          title: t('__common.__group'),
          key: "group",
          sort: true,
        },
        {
          title: t('__common.__message'),
          key: "message",
        },
        {
          title: t('__d7d_n17r.__date'),
          key: "date",
          sort: true,
        },
      ]
      let other_col = [
        {
          title: t('__d7d_n17r.__serialNumber'),
          key: "serialNumber",
          isLink: true, //有連結
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "pcName",
          sort: true,
        },
        {
          title: t('__common.__group'),
          key: "group",
          sort: true,
        },
        {
          title: t('__common.__message'),
          key: "message",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__date'),
          key: "date",
          sort: true,
        },
      ]
      if (state.tab == "join") {
        col = join_col;
      } else if (state.tab == "unlock") {
        col = unlook_col;
      } else if (state.tab == "unbind") {
        col = unbind_col;
      } else if (state.tab == "other") {
        col = other_col;
      }
      return col
    })


    const _init = (isNeedLoading = true) => {
      getAPINotificationsData(isNeedLoading);
      getAPIGetGroupModel(isNeedLoading);
    } //end: init

    const getAPINotificationsData = async (isNeedLoading = true) => {// orgDBD
      store.commit('setIsNeedLoading', isNeedLoading);
      console.log('getAPINotificationData', state.tab);
      try {
        var _post_data = {
          per_page: 10,
        }
        _post_data["page"] = state.meta.current;
        _post_data["type"] = state.tab;
        if (state.device.val != "All") {
          if (state.device.val == state.device.text) {
            _post_data["model"] = state.device.val;
          } else {
            _post_data["group"] = state.device.val;
          }
        }
        //function_name

        if (state.function_name.val != "All") {
          _post_data["unlock_task"] = state.function_name.val == 'unlock_task' ? true : false;
          _post_data["unlock_osd"] = state.function_name.val == 'unlock_osd' ? true : false;
        }
        if (state.sort.key != "All") {
          _post_data["sort"] = state.sort.key
          if (state.sort.key == "date") {
            _post_data["sort"] = "created_at";
          } else if (state.sort.key == "serialNumber") {
            _post_data["sort"] = "ssn";
          } else if (state.sort.key == "pcName") {
            _post_data["sort"] = "host";
          } else if (state.sort.key == "ipAddress") {
            _post_data["sort"] = "ip"
          } else if (state.sort.key == "requirement") {
            _post_data["sort"] = "unlock_task"
          }
          if (state.sort.val == "up") {
            _post_data["order"] = "asc"
          } else if (state.sort.val == "down") {
            _post_data["order"] = "desc"
          }
        }
        const data = await apiGetNotifications(_post_data);
        multiLang.initRawData = data;
        console.log('Notifications api data', data);
        //#region tab
        for (var _t = 0; _t < state.tab_data.length; _t++) {
          if (state.tab_data[_t].id == "join") {
            state.tab_data[_t].alertText = data.join_news.toString();
          } else if (state.tab_data[_t].id == "unlock") {
            state.tab_data[_t].alertText = data.unlock_news.toString();
          } else if (state.tab_data[_t].id == "unbind") {
            state.tab_data[_t].alertText = data.unbind_news.toString();
          } else if (state.tab_data[_t].id == "other") {
            state.tab_data[_t].alertText = data.other_news.toString();
          }
        }
        //#endregion
        //#region table

        //重新計算header 訊息總數
        getAPINotificationsNew()

        orgDBD()
        //#endregion
        //#region page
        // console.log('gfdhgjhkj',state.deviceListData)
        state.meta.total_page = data.last_page;
        //#endregion
      }
      catch (err) {
        console.log("apiGetNotifications", 'err')
      }
    }
    const getAPIGetGroupModel = async (isNeedLoading = true) => {
      store.commit('setIsNeedLoading', isNeedLoading);
      try {
        const data = await apiGetGroupModel();
        // console.log('Group api data', data);
        state.device_op = [
          {
            text: t('__d7d_n17r.__allFunctions'),
            val: 'All',
            id: "All",
            isI18n: '__d7d_n17r.__allFunctions',
          },
        ]
        if (data.model.length > 0) {
          var _op = {
            text: t('__common.__model'),
            val: "model",
            id: "model",
            isI18n: '__common.__model',
            sub: []
          }
          for (var a = 0; a < data.model.length; a++) {
            var _g = {
              text: data.model[a],
              val: data.model[a],
              id: "model",
              isI18n: false
            }
            _op.sub.push(_g);
          }
          state.device_op.push(_op);
        }
        state.askOP = JSON.parse(JSON.stringify(state.device_op));//深拷貝
        console.log('state.tab', state.askOP)
        if (data.groups.length > 0) {
          _op = {
            text: t('__common.__group'),
            val: "group",
            id: "group",
            isI18n: '__common.__group',
            sub: []
          }
          for (a = 0; a < data.groups.length; a++) {
            _g = {
              text: data.groups[a].name,
              val: data.groups[a].id,
              id: "group",
              isI18n: false
            }
            _op.sub.push(_g);
          }
          state.device_op.push(_op);
        }

      }
      catch (err) {
        console.log("apiGetGroupModel", 'err')
      }
    }
    const selectDevice = () => {
      state.meta.current = 1
      state.defaultCheckIndexList = [];
      getAPINotificationsData();
    }

    const selectFunction = () => {
      state.meta.current = 1
      state.defaultCheckIndexList = [];
      getAPINotificationsData();
    }
    //mounted
    return {
      state,
      iconSrc,
      onClick,
      IsChecked,
      tableSort,
      onCheckAll,
      onCheckEach,
      goTableLink,
      showCTAndRow,
      changePage,
      onClickTab,
      approve_click,
      delete_click,
      t,
      colComputed,
      orgDBD,
      getAPINotificationsNew,
      selectDevice,
      selectFunction
    }
  }
}


